import "./KitchenRemodeling2.module.css";
import Header from "@/reusable_sections/Header";
import HeroKitchenRemodelAnswer from "./sections/HeroKitchenRemodelAnswer";
import RemodelConsiderations from "./sections/RemodelConsiderations";
import KitchenTimeline from "./sections/KitchenTimeline";
import KitchenProcess from "./sections/KitchenProcess";
import KitchenRemodelingFaq from "./sections/KitchenRemodelingFaq";
import RemodelingEstimateCta from "./sections/RemodelingEstimateCta";
import KitchenCta from "./sections/KitchenCta";
import EstimateRequest from "./sections/EstimateRequest";
import Footer from "@/reusable_sections/Footer";
export default function KitchenRemodeling2Page() {
  return <div>
      <Header />
      <HeroKitchenRemodelAnswer />
      <RemodelConsiderations />
      <KitchenCta />
      <KitchenTimeline />
      <KitchenProcess />
      <KitchenRemodelingFaq />
      <EstimateRequest />
      <RemodelingEstimateCta />
      <Footer />
    </div>;
}